import React from 'react';
import Link from 'components/Link';
import {HtmlParse} from 'utils';
import TagManagerService from 'services/TagManager';
import { preFooterTxt } from 'config/translate/variables';
import helpCenter from 'images/help-center/cencommerce-help-center.svg';
import status from 'images/help-center/cencommerce-status.svg';
import stores from 'images/help-center/cencommerce-stores.svg';
import troubles from 'images/help-center/cencommerce-troubles.svg';
import style from './style.scss';//NOSONAR

const PreFooter = () => {

    const clickPreFooterInfo = (action, tag) => {
        TagManagerService.homeBody(action, tag);
    }

    return (
        <section className="prefooter">
            <div className="center">
                <Link
                    className="prefooter-link mobile-click"
                    to="https://ayuda.jumbo.cl/"
                    onClick={() => clickPreFooterInfo('Centro de Ayuda', window.location.href)}
                    target="_blank"
                >
                    <div className="helpcenter-icon">{HtmlParse(helpCenter)}</div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.faq.title}</h2>
                        <h3 className="text">{preFooterTxt.faq.subtitle}</h3>
                    </div>
                </Link>
                <Link
                    className="prefooter-link mobile-click"
                    to="/mis-compras"
                    onClick={() => clickPreFooterInfo('Seguimiento', window.location.href)}
                >
                    <div className="helpcenter-icon">{HtmlParse(status)}</div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.tracking.title}</h2>
                        <h3 className="text">{preFooterTxt.tracking.subtitle}</h3>
                    </div>
                </Link>
                <Link
                    className="prefooter-link mobile-click"
                    to="https://ayuda.jumbo.cl/ayuda/problemas-pedido/producto-cobrado-no-enviado"
                    onClick={() => clickPreFooterInfo('Pagos', window.location.href)}
                    target="_blank"
                >
                    <div className="helpcenter-icon">{HtmlParse(troubles)}</div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.order.title}</h2>
                        <h3 className="text">{preFooterTxt.order.subtitle}</h3>
                    </div>
                </Link>
                <Link
                    className="prefooter-link mobile-click"
                    to="/locales"
                    onClick={() => clickPreFooterInfo('Entregas', window.location.href)}
                >
                    <div className="helpcenter-icon">{HtmlParse(stores)}</div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.stores.title}</h2>
                        <h3 className="text">{preFooterTxt.stores.subtitle}</h3>
                    </div>
                </Link>
            </div>
        </section>
    )
}

export default PreFooter;
